import { LoadableAfterPaint } from '@confluence/loadable';

export const TreeMonitorLoader = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-TreeMonitor" */ '../src/TreeMonitor.tsx'))
			.TreeMonitor,
});
